import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import {withStyles} from '@material-ui/core/styles'
import notfoundsvg from '../images/404.svg'

const styles = theme => ({
    buttoncontained: {
        color: 'white',
        backgroundColor: '#00853e',
        alignContent: 'center',
        alignItems: 'center',
        textTransform: 'none',
        padding: '5px 17%',
        boxSizing: 'border-box',
        borderRadius: '2px',
        marginLeft: '2px',
        marginRight: '2px',
        '&:hover': {
            backgroundColor: '#00652A',
        },
    },
    box: {
        margin: '0 auto',
        left: 0,
        right: 0,
        width: '50%',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            paddingTop: '103px',
        },
        [theme.breakpoints.down('xl')]: {
            maxWidth: '536px',
            maxHeight: '531px',
            paddingTop: '112px',
        },
    },
    imagebox: {
        margin: '0 auto',
        left: 0,
        right: 0,
        width: '214px',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            width: '180px',
        },
    },
    buttontext: {
        textDecoration: 'none',
    },
})

function NotFound(props) {
    const {classes} = props

    return (
        <div className={classes.box}>
            <img alt="" src={notfoundsvg} className={classes.imagebox} />

            <Typography
                variant="h3"
                align="center"
                style={{
                    margin: '36px 0 48px 0',
                    fontWeight: '300',
                }}
            >
                Oops! Page not found.
            </Typography>

            <Button
                variant="contained"
                size="medium"
                className={classes.buttoncontained}
                component={RouterLink}
                to={'/swiping'}
            >
                Take me home
            </Button>
        </div>
    )
}
export default withStyles(styles)(NotFound)
